export default "__VITE_ASSET__0FlcKNol__"